// DEV-2118 — Zirve e-İmza Servisi kurulum dosyalarının indirme bağlantıları.
// Amaç: kullanıcı e-imza servisini yalnızca giriş ekranından değil, cloud oturumu
// açıldıktan sonra da (üst bar "İndirmeler" menüsü ve "Uyap Bağlantısı Yok" ekranı)
// indirebilsin. Tek merkezî kaynak — link/etiket değişirse YALNIZCA burası güncellenir
// (RehberVideolari.ts ile aynı yaklaşım).
//
// İsimlendirme giriş ekranıyla birebir aynıdır: Windows, MacOs, MacOs ARM.
// Kullanıcıya işletim sistemine göre gösterilir: Windows'ta yalnız Windows,
// Mac'te iki Mac paketi (x64 + arm64). Tanınmayan sistemde hepsi gösterilir.

/** İndirme paketinin ait olduğu işletim sistemi ailesi. */
export type IsletimSistemiAilesi = "windows" | "mac";

/** Kullanıcının tespit edilen işletim sistemi ("diger" = Windows/Mac dışı ya da bilinmiyor). */
export type IsletimSistemi = IsletimSistemiAilesi | "diger";

export interface EImzaServisIndirme {
  /** Kullanıcıya gösterilen platform adı (giriş ekranıyla aynı: Windows / MacOs / MacOs ARM). */
  platform: string;
  /** Bu paketin hangi işletim sistemi ailesine ait olduğu (OS'a göre filtreleme için). */
  os: IsletimSistemiAilesi;
  /** Platform simgesi (mdi ikon adı). */
  icon: string;
  /** İndirme bağlantısı (CDN). Değiştirilmeden birebir kullanılmalıdır. */
  url: string;
}

/** İndirme bağlantılarının ortak etiketi. */
export const EIMZA_SERVIS_INDIR_ETIKET = "e-İmza Servisi İndir";

/**
 * Sıralama giriş ekranıyla aynı: Windows, MacOs (x64), MacOs ARM (arm64).
 * İki ayrı macOS paketi vardır; Mac kullanıcısına ikisi de sunulmalıdır.
 */
export const EImzaServisIndirmeleri: ReadonlyArray<EImzaServisIndirme> = [
  {
    platform: "Windows",
    os: "windows",
    icon: "mdi-microsoft-windows",
    url: "https://cdn.zirve-bilgisayar.com/imza/latest/zirve-bilgisayar-e-imza-win.exe",
  },
  {
    platform: "MacOs",
    os: "mac",
    icon: "mdi-apple",
    url: "https://cdn.zirve-bilgisayar.com/imza/latest/zirve-bilgisayar-e-imza-mac-x64.dmg",
  },
  {
    platform: "MacOs ARM",
    os: "mac",
    icon: "mdi-apple",
    url: "https://cdn.zirve-bilgisayar.com/imza/latest/zirve-bilgisayar-e-imza-mac-arm64.dmg",
  },
];

/**
 * Tarayıcıdan işletim sistemini tespit eder. Modern `userAgentData.platform`
 * önce denenir; yoksa eski `platform` / `userAgent` alanlarına düşülür.
 * Not: Apple Silicon Mac'lerde tarayıcı uyumluluk için "MacIntel" bildirir; bu yüzden
 * Mac'te Intel/ARM ayrımı yapılmaz, iki Mac paketi birlikte sunulur.
 */
export function isletimSistemiTespitEt(nav: Navigator = navigator): IsletimSistemi {
  const uaData: any = (nav as any).userAgentData;
  const platform = String(uaData?.platform || nav.platform || "").toLowerCase();
  const ua = String(nav.userAgent || "").toLowerCase();

  if (platform.includes("win") || ua.includes("windows")) return "windows";
  if (platform.includes("mac") || ua.includes("mac")) return "mac";
  return "diger";
}

/**
 * Verilen işletim sistemine göre gösterilecek indirme seçeneklerini döndürür.
 * Windows → yalnız Windows; Mac → iki Mac paketi; diğer/bilinmiyor → hepsi
 * (hiçbir kullanıcı dosyalara erişimsiz kalmasın).
 */
export function eImzaIndirmeleriGetir(
  os: IsletimSistemi = isletimSistemiTespitEt()
): EImzaServisIndirme[] {
  if (os === "windows" || os === "mac") {
    return EImzaServisIndirmeleri.filter(item => item.os === os);
  }
  return EImzaServisIndirmeleri.slice();
}
